<template>
    <div class="member-wall-container">
        <memberBottomButton v-if="isShowButton" @show-popup="triggerMemberPopup(true)" />

        <memberPopup ref="popup" @close-popup="handleClosePopup" />
    </div>
</template>

<script>
import memberPopup from './components/memberPopup/index';
import memberBottomButton from './components/memberBottomButton/index';
import { isMember } from './api/index';

export default {
    components: { memberPopup, memberBottomButton },
    props: {
        isShowButton: {
            type: Boolean,
            default: false,
        },
    },
    created() {
        this.getUserMemberInfo();
    },
    methods: {
        triggerMemberPopup() {
            // this.$refs.popup.mutationShowPopup(status);

            // 暂时不弹窗
            const link = `${location.origin}/new/card/views/collect/upgradeMember.html?channelHash=291ca7c0ad51846b311e887918758406&pageTag=poqiangbanka1`;
            location.href = link;
        },

        async getUserMemberInfo() {
            const { code, data } = await isMember();
            if (code === 0 && data && !data.member) {
                this.$emit('user-isn-member', true);
            }
        },

        handleClosePopup() {
            this.$emit('close-popup');
        },
    },
};
</script>

<style lang="scss" scoped>
.member-wall-container {
}
</style>
